import { CheckmarkCircleIcon } from '@datacamp/waffles-icons';
import React from 'react';
var thanksStyle = {
  alignItems: 'center',
  display: 'flex',
  flexBasis: '100%',
  justifyContent: 'center'
};

var ThanksForRating = function ThanksForRating(_ref) {
  var ratedMessage = _ref.ratedMessage;
  return /*#__PURE__*/React.createElement("div", {
    style: thanksStyle
  }, /*#__PURE__*/React.createElement(CheckmarkCircleIcon, {
    className: "dc-u-mr-4"
  }), /*#__PURE__*/React.createElement("p", {
    className: "dc-u-m-4"
  }, ratedMessage));
};

export default ThanksForRating;